import React, { Component } from 'react';
import UsersComponent from '../../../../../../components/Users';
import { Route, Switch } from 'react-router';

// Screens.
import User from './screens/User';
import CreateUser from './screens/CreateUser';

/**
 * Users screen, for showing list of users.
 *
 * @extends React.Component
 */
class Users extends Component {
  render() {
    return (
      <Switch>
        <Route exact path={`${this.props.match.path}`} component={UsersComponent} />
        <Route exact path={`${this.props.match.path}/create`} component={CreateUser} />
        <Route path={`${this.props.match.path}/:userId`} component={User} />
      </Switch>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/Users/index.js